// @owners { team: patients }
import { type Brand, getBrand } from '@alto/design-system';

export type CompanyName = 'FuzeRx';
export type CompanyFullName = 'FuzeRx';

const COMPANY_NAME: Record<Brand, CompanyName> = {
  fuzerx: 'FuzeRx',
};

const COMPANY_FULL_NAME: Record<Brand, CompanyFullName> = {
  fuzerx: 'FuzeRx',
};

/**
 * Get the company display name based on the current brand.
 * @returns CompanyName ('FuzeRx')
 */
export const getCompanyName = (): CompanyName => COMPANY_NAME[getBrand()];

/**
 * Get the company's full display name based on the current brand.
 * @returns CompanyFullName ('FuzeRx')
 */
export const getCompanyFullName = (): CompanyFullName => COMPANY_FULL_NAME[getBrand()];
